export let DATABASE_SCHEMA = "";

const BACKEND_BASE_URL_LOCAL        = "http://localhost:8081/";
const BACKEND_BASE_URL_IP_DEV       = "http://10.202.21.180:7002/be-advised/";
const BACKEND_BASE_URL_DOMAIN_DEV   = "https://beadvised-api-dev.tessib.com/be-advised/";
const BACKEND_BASE_URL_IP_QA        = "http://10.202.21.182:7002/be-advised/";
const BACKEND_BASE_URL_DOMAIN_QA    = "https://beadvised-api-qa.tessib.com/be-advised/";
const BACKEND_BASE_URL_PRODUCTION   = "https://myadvice.amanahapp.run/be-advised/";
const BACKEND_BASE_URL_RHEL_AMANAH  = "https://rhel-amanah.netbird.cloud/be-advised/";

const BACKEND_BASE_URL_DOMAIN_PROD  = "https://beadvised-api.bankbsi.co.id/be-advised/";

function getBackendBaseUrls() {
  const pageHost = window.location.hostname.toLowerCase();

  if (pageHost === "localhost" || pageHost === "127.0.0.1") {
    return [BACKEND_BASE_URL_LOCAL];
  }

  // Ini untuk pakai IP DEV
  if (pageHost === "10.202.21.174") {
    return [BACKEND_BASE_URL_IP_DEV];
  }

  // Ini untuk pakai DOMAIN DEV
  if (pageHost === "beadvised-dev.tessib.com") {
    return [BACKEND_BASE_URL_DOMAIN_DEV];
  }
  
  // Ini untuk pakai IP QA
  if (pageHost === "10.202.21.175") {
    return [BACKEND_BASE_URL_IP_QA];
  }

  // Ini untuk pakai DOMAIN QA
  if (pageHost === "beadvised-qa.tessib.com") {
    return [BACKEND_BASE_URL_DOMAIN_QA];
  }

  if (pageHost === "beadvised.amanahapp.run") {
    return [BACKEND_BASE_URL_PRODUCTION, BACKEND_BASE_URL_RHEL_AMANAH];
  }

  // Ini untuk pakai DOMAIN PROD
  if (pageHost === "beadvised.bankbsi.co.id") {
    return [BACKEND_BASE_URL_DOMAIN_PROD];
  }

  return [BACKEND_BASE_URL_PRODUCTION, BACKEND_BASE_URL_RHEL_AMANAH];
}

export async function loadRuntimeConfig() {
  const failures = [];

  for (const baseUrl of getBackendBaseUrls()) {
    const url = `${baseUrl.replace(/\/$/, "")}/runtime-config`;

    try {
      const response = await fetch(url, {
        cache: "no-store",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const contentType = response.headers.get("content-type") || "unknown content type";
      if (!contentType.toLowerCase().includes("application/json")) {
        throw new Error(`expected JSON, received ${contentType}`);
      }

      const config = await response.json();
      const schema = String(config?.databaseSchema || "").trim().toUpperCase();
      if (!schema) {
        throw new Error("backend runtime config did not provide databaseSchema");
      }

      DATABASE_SCHEMA = schema;
      return;
    } catch (error) {
      failures.push(`${url}: ${error?.message || "request failed"}`);
    }
  }

  throw new Error(`Backend runtime config gagal dimuat. ${failures.join(" | ")}`);
}
